<div class="image-modal-container">
    @for (url of imageUrls; track $index) {
        @if ($index === currentIndex) {
            <img [src]="url | secure | async"
                (load)="onImageLoad()"
                [class.loaded]="imageLoaded"
                class="main-image"/>
        }
    }

    <button class="close-button" (click)="onClose()">
        <span class="material-symbols-outlined">close</span>
    </button>

    <button class="nav-button nav-prev" (click)="previousImage()" [disabled]="currentIndex === 0">
        <span class="material-symbols-outlined">chevron_left</span>
    </button>

    <button class="nav-button nav-next" (click)="nextImage()" [disabled]="currentIndex === imageUrls.length - 1">
        <span class="material-symbols-outlined">chevron_right</span>
    </button>

    <div class="image-counter">{{ currentIndex + 1 }} / {{ imageUrls.length }}</div>
</div>